<template>
  <div
    v-if="brand"
    class="text-muted">
    <span class="me-1">Brand:</span>
    <a
      href="#"
      @click="browseBrand">
      {{ brand }}
    </a>
  </div>
</template>

<script>
  export default {
    props: ['brand'],
    methods:{
      browseBrand(){
        this.$router.push({
          name: 'ProductSearch',
          query: {
            action: 'browseBrand',
            brand: this.brand
          }
        })
      }
    }
  }
</script>